import React, { useState } from 'react';
import { toast } from 'react-toastify';

const AddBedTypeModal = ({ isOpen, onClose, onSaveBedType }) => {
  const [typeName, setTypeName] = useState('');
  const [description, setDescription] = useState('');
  const [status, setStatus] = useState('Active');

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!typeName.trim()) {
      toast.error('Please enter a bed type name');
      return;
    }

    onSaveBedType({
      name: typeName.trim(),
      description: description.trim(),
      status: status
    });

    setTypeName('');
    setDescription('');
    onClose();
  };

  return (
    <div className="manage-modal-backdrop" onClick={onClose}>
      <div className="manage-modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="manage-modal-header">
          <h3>🛏️ Add New Bed Type</h3>
          <button className="manage-modal-close" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="manage-modal-body">
            <div className="modal-form-group">
              <label>* Bed Type Name</label>
              <input
                type="text"
                placeholder="e.g. Standard Adjustable Bed, Electric ICU Bed, Pediatric Bed"
                value={typeName}
                onChange={(e) => setTypeName(e.target.value)}
                autoFocus
                required
              />
            </div>

            <div className="modal-form-group">
              <label>Description / Specification</label>
              <input
                type="text"
                placeholder="e.g. 3-function motorized bed with side rails"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>

            <div className="modal-form-group">
              <label>* Status</label>
              <select value={status} onChange={(e) => setStatus(e.target.value)}>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
          </div>

          <div className="manage-modal-footer">
            <button type="button" className="modal-btn-cancel" onClick={onClose}>Cancel</button>
            <button type="submit" className="modal-btn-save">Save Bed Type</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddBedTypeModal;
